import { render } from "./BaseSwitch.vue?vue&type=template&id=5260a8d2&scoped=true"
import script from "./BaseSwitch.vue?vue&type=script&lang=js"
export * from "./BaseSwitch.vue?vue&type=script&lang=js"

import "./BaseSwitch.vue?vue&type=style&index=0&id=5260a8d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5260a8d2"]])

export default __exports__